import { useMemo } from 'react';
import { useTierQueryParam } from '../../../hooks/useTierQueryParam';
import { filterProductsConfigByTab } from '../../utils/tabFiltering';
import { useIsUngatedForV2PublicHubPages } from '../gating/useIsUngated';
import { useIsInAppAuth } from '../user/useUserInfo';
export const useTabAwareProductsConfig = fullConfig => {
  const tier = useTierQueryParam();
  const isInAppAuth = useIsInAppAuth();
  const showPublicTabsOnV2 = useIsUngatedForV2PublicHubPages();
  return useMemo(() => {
    const isPublic = !isInAppAuth;

    // In-app pages: always show all products
    if (!isPublic || !showPublicTabsOnV2) {
      return fullConfig;
    }

    // V2 public pages: use tier query param instead of tab URL segment
    // When tier=enterprise, show only Professional and Enterprise
    // Otherwise, show all products
    if (tier === 'enterprise') {
      return filterProductsConfigByTab(fullConfig, 'enterprise');
    }
    return fullConfig;
  }, [fullConfig, tier, isInAppAuth, showPublicTabsOnV2]);
};